import React, { Component } from "react";
import {
  sendSMS,
  mobileValidateOTP,
  validateActivationCode,
  reSendSMS,
  mobileOTPLogin,
} from "../api/api";
import { withTranslation } from "react-i18next";
import { getParameter } from "../util/util";

class MobileLogin extends Component {
  //Login Information
  state = {
    prefixMobileNum: "+966",
    mobileNumber: "",
    nationalNumber: "",
    idNumber: "",
    errors: {},
    loading: false,
    userNameLine: "",
    pinCode: "",
    extraParam: "",
    resendCounter: 0,
  };

  handleMobileNumberChange = (evt) => {
    const prefixNum = /^((\+966(\d{0}|[0-9\b]+))|((\+9665|\+96605|\+966100|\+96618)([0-9]{8}|[0-9]{13}|[0-9]{7})))$/;
  
    if (evt.target.length >= 4 || prefixNum.test(evt.target.value)) {  
      this.setState({
        mobileNumber: evt.target.value.substring(1),
        prefixMobileNum: evt.target.value,
      });
    }
  };

  handleNationalNumberChange = (evt) => {
    const re = /^[0-9\b]+$/;
    if (evt.target.value === "" || re.test(evt.target.value)) {
      this.setState({
        nationalNumber: evt.target.value,
      });
    }
  };

  handlePinChange = (evt) => {
    const re = /^[0-9\b]+$/;
    if (evt.target.value === "" || re.test(evt.target.value)) {
      this.setState({
        pinCode: evt.target.value,
      });
    }
  };

  handaleSubmit = async (e) => {
    e.preventDefault();
    if (this.validateForm()) {
      this.setState({
        loading: true,
      });

      const user = await sendSMS(
        this.state.mobileNumber,
        this.state.nationalNumber,
        window.lang
      );

      if (user.data.status == 200) {
        if (user.data.message == "customer not found") {
          let errors = {};
          errors["customError"] = "invalid_subscription_information";

          this.setState({
            errors: errors,
            loading: false,
          });
        } else if (user.data.message == "Y") {
          //First Case Login  Consumer
          if (user.data.response.idNumber) {
            this.setState({
              idNumber: user.data.response.idNumber,
              userNameLine: user.data.response.userName,
              extraParam: "Y",
            });
          }
        } else if (user.data.message == "N") {
          let errors = {};
          errors["customError"] = "user_not_register";

          this.setState({
            errors: errors,
            loading: false,
          });
        } else if (user.data.message == "Not Matching") {
          let errors = {};
          errors["customError"] = "not_matching";

          this.setState({
            errors: errors,
            loading: false,
          });
        } else {
          let errors = {};
          errors["customError"] = "error";

          this.setState({
            errors: errors,
            loading: false,
          });
        }
      }

      if (user.data.status == 410) {
        let errors = {};
        errors["customError"] = "corporate_user_error";
        this.setState({
          errors,
          loading: false,
        });
      }
    }

    this.setState({
      loading: false,
    });
  };

  validateForm() {
    let errors = {};
    let formIsValid = true;

    if (!this.state.mobileNumber) {
      formIsValid = false;
      errors["mobileNumber"] = "mobile_number_required";
    }

    const mobileNumberRegular = /^[0-9]{12,15}$/;
    if (
      this.state.mobileNumber &&
      !mobileNumberRegular.test(this.state.mobileNumber)
    ) {
      formIsValid = false;
      errors["mobileNumber"] = "mobile_number_format";
    }

    if (!this.state.nationalNumber) {
      formIsValid = false;
      errors["nationalNumber"] = "national_number_required";
    }

    if (!this.state.pinCode && this.state.userNameLine) {
      formIsValid = false;
      errors["pinCode"] = "pin_code_required";
    }

    this.setState({
      errors: errors,
    });

    return formIsValid;
  }

  resendSMS = async () => {
    this.setState({
      loading: true,
    });
    
    let message = '';
    if(this.state.resendCounter < 4) {
      const response = await reSendSMS(this.state.mobileNumber, window.lang);
      message = response.data.message;
      this.setState({
        resendCounter: this.state.resendCounter + 1,
        loading: false,
      });
    } else {
      message = 'exceeded_max_requests';
    }

    if(message !== 'success') {
      let errors = {};
      errors["customError"] = message;
      this.setState({
        errors: errors,
        loading: false,
      })
    }
  };

  handleValidateActivationCode = async () => {
    const response = await validateActivationCode(
      this.state.mobileNumber, //mobileNumberLine
      this.state.pinCode //sms code
    );
    let message = response.data.message;

    if(message === 'VALID_OTP') {
      this.handaleValidateOTP();
    } else {
      let errors = {};
      errors["customError"] = message;
      this.setState({
        errors: errors,
        loading: false,
      });
    }
  }

  handaleValidateOTP = async () => {
    if (this.validateForm()) {
      this.setState({
        loading: true,
      });

      const result = await mobileValidateOTP(
        this.state.userNameLine, //username
        "", //password
        "OTP", //Login Source
        "Y", //login_extra_para
        window.lang, //locale
        "", //email Address
        "", //client Id
        this.state.mobileNumber, //mobileNumberLine
        this.state.pinCode //sms code
      );
      console.log("After result:" + result);
      if (result === "Error") {
        let errors = {};
        errors["customError"] = "pin_Code_incorrect";

        this.setState({
          errors: errors,
          loading: false,
        });
      }
    }
  };

  render() {
    const { t } = this.props;

    const { loading, mobileNumber } = this.state;
    const accountType = getParameter("account_type");

    return (
      <div>
        {/* red alert  */}
        {this.state.errors.customError ? (
          <div className="alert alert-danger" role="alert">
            {t(this.state.errors.customError)}{" "}
            <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
          </div>
        ) : null}
        {/* red alert  */}

        {/* warnning alert  */}
        {this.state.idNumber &&
        !this.state.errors.customError &&
        !this.state.loading ? (
          <div className="alert alert-danger" role="alert">
            {t("warnning_alert_sms")}{" "}
            {this.state.mobileNumber.replace(/.(?=.{3})/g, "x")}.
          </div>
        ) : null}
        {/* warnning alert  */}
        {accountType != "auctions" ? (
          <form id="mobile-login-form" onSubmit={this.handaleSubmit}>
            <div
              className={
                "form-group " +
                (this.state.errors.mobileNumber ? "not-valid" : "")
              }
            >
              <label
                className="input-label "
                style={{
                  visibility: this.state.mobileNumber ? "visible" : "hidden",
                }}
              >
                {t("mobile_number")}
              </label>
              <input
                id="login-mobileno"
                type="text"
                className="form-control mobileNumberInput"
                placeholder={t("mobile_number")}
                value={this.state.prefixMobileNum}
                onChange={this.handleMobileNumberChange}
                readOnly={this.state.idNumber}
                maxLength={mobileNumber.startsWith('05') ? 10 : mobileNumber.startsWith('9665') ? 13 : mobileNumber.startsWith('96618') ? 13 : 16}
              />

              {/* red alert  */}
              {this.state.errors.mobileNumber ? (
                <div className="alert alert-danger" role="alert">
                  {t(this.state.errors.mobileNumber)}{" "}
                  <i
                    className="fa fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                </div>
              ) : (
                <div className="empty-alert">&nbsp;</div>
              )}
              {/* red alert  */}
            </div>

            {!this.state.idNumber ? (
              <div
                className={
                  "form-group " +
                  (this.state.errors.nationalNumber ? "not-valid" : "")
                }
              >
                <label
                  className="input-label"
                  style={{
                    visibility: this.state.nationalNumber
                      ? "visible"
                      : "hidden",
                  }}
                >
                  {t("national_number")}
                </label>
                <input
                  id="login-nationalid"
                  type="text"
                  className="form-control"
                  placeholder={t("national_number")}
                  value={this.state.nationalNumber}
                  onChange={this.handleNationalNumberChange}
                  maxLength="50"
                />

                {/* red alert  */}
                {this.state.errors.nationalNumber ? (
                  <div className="alert alert-danger" role="alert">
                    {t(this.state.errors.nationalNumber)}{" "}
                    <i
                      className="fa fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                  </div>
                ) : (
                  <div className="empty-alert">&nbsp;</div>
                )}
                {/* red alert  */}
              </div>
            ) : null}

            {this.state.idNumber ? (
              <div
                className={
                  "form-group " + (this.state.errors.pinCode ? "not-valid" : "")
                }
              >
                <label
                  className="input-label"
                  style={{
                    visibility: this.state.pinCode ? "visible" : "hidden",
                  }}
                >
                  {t("pin_code")}
                </label>
                <input
                  type="text"
                  id="pincode"
                  className="form-control"
                  placeholder={t("pin_code")}
                  pattern="[0-9]*"
                  maxLength="10"
                  value={this.state.pinCode}
                  onChange={this.handlePinChange}
                />
                {/* red alert  */}

                {this.state.errors.pinCode ? (
                  <div className="alert alert-danger" role="alert">
                    {t(this.state.errors.pinCode)}
                    <i
                      className="fa fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                  </div>
                ) : (
                  <div className="empty-alert">&nbsp;</div>
                )}
                {/* red alert  */}
              </div>
            ) : null}

            {this.state.idNumber ? (
              <p className="forget_pass" id="resendSMS">
                <a href="javascript:void(0);" onClick={this.resendSMS}>
                  {t("resend_sms")}
                </a>
              </p>
            ) : null}

            {!this.state.idNumber ? (
              <p className="forget_pass" id="forgotPassword">
                <a href={window.FORGOT_ACCOUNT_LINK}>{t("forget_password")}</a>
              </p>
            ) : null}

            {!this.state.idNumber ? <p>{t("mobile_login_dec")}</p> : null}

            {!this.state.userNameLine ? (
              <button
                id="send-sms"
                type="submit"
                className="btn min_outlin_btn active"
              >
                {t("send_sms")}{" "}
                <i className="fa fa-arrow-right" aria-hidden="true"></i>
              </button>
            ) : null}

            {this.state.userNameLine ? (
              <button
                type="button"
                id="login-btn"
                className="btn min_outlin_btn active"
                onClick={this.handleValidateActivationCode}
              >
                {t("login")}{" "}
                <i className="fa fa-arrow-right" aria-hidden="true"></i>
              </button>
            ) : null}

            <a
              href={
                accountType == "business"
                  ? window.REGISTRATION_LINK + "?account_type=business"
                  : window.REGISTRATION_LINK + "?account_type=personal"
              }
            >
              <button
                id="signup-btn"
                type="button"
                className="btn min_outlin_btn"
              >
                {t("signup")} {loading}
                <i className="fa fa-arrow-right" aria-hidden="true"></i>
              </button>
            </a>
            <a
              href={window.generateFacebookAuthURL}
              className="btn min_outlin_btn"
              style={{ display: "none" }}
            >
              <span>
                <i className="fab fa-facebook-f"></i>
                {t("face_book")}
              </span>
              <i className="fa fa-arrow-right"></i>
            </a>
          </form>
        ) : null}
        {loading ? <div className="loading">Loading&#8230;</div> : null}
      </div>
    );
  }
}
export default withTranslation()(MobileLogin);
